import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { Col, Form, message, Radio, Row, Select, Spin, Tag } from "antd"
import { LoadingOutlined } from "@ant-design/icons"

// Components
import Button from "src/components/MyButton/Button"
import CRMService from "src/services/CRMService"
import DepartmentService from "src/services/DepartmentService"
import { SelectStyle } from "../common/styled"

const ModalAssigner = props => {
  const { onCancel, open, getData, dataSelected, status, setSelectedRowKeys } =
    props

  const [form] = Form.useForm()
  const [assignerList, setAssignerList] = useState([])
  const [loading, setLoading] = useState(false)
  const [listDepartment, setListDepartment] = useState([]) // thay redux
  const [departmentId, setDepartmentId] = useState([]) // thay mảng rỗng
  const [assignType, setAssignType] = useState("department")

  // cache danh sách personnel theo deptId
  const personnelCache = useRef({})

  // fetch department 1 lần duy nhất
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const departmentRes = await DepartmentService.getAllDept()
        setListDepartment(departmentRes.success || [])
      } catch (err) {
        console.error("Error fetching department:", err)
      }
    }
    fetchDepartment()
  }, [])

  const fetchPersonnelList = async deptId => {
    if (!deptId || (Array.isArray(deptId) && deptId.length === 0)) {
      setAssignerList([])
      return
    }

    const cacheKey = Array.isArray(deptId) ? [...deptId].sort().join(",") : deptId
    if (personnelCache.current[cacheKey]) {
      setAssignerList(personnelCache.current[cacheKey])
      return
    }

    setLoading(true)
    try {
      const response = await CRMService.getListPersonnel({
        department_id: deptId,
        positions: [1, 2, 3, 4],
      })

      if (!response) {
        message.error("Không thể lấy danh sách người phụ trách!")
        return
      }

      const formattedData = response?.data
        .filter(person => person?.user?.is_locked === 0)
        .map(item => ({
          ...item,
          name: item.name,
        }))

      personnelCache.current[cacheKey] = formattedData
      setAssignerList(formattedData)
    } catch (error) {
      console.log("fetchPersonnelList error", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPersonnelList(departmentId)
  }, [departmentId])

  const handleSave = async () => {
    if (assignType === "department" && (!departmentId || departmentId.length === 0)) {
      message.warning("Vui lòng chọn ít nhất một phòng ban!")
      return
    }
    try {
      const values = await form.validateFields()
      if (assignType === "person" && (!values.assigner || values.assigner.length === 0)) {
        message.warning("Vui lòng chọn ít nhất một nhân viên sale!")
        return
      }
      setLoading(true)

      const ids =
        open[0] === true ? [...dataSelected] : [...open, ...dataSelected]
      const payload = {
        ids,
        ...(assignType === "department"
          ? { departmentId }
          : { personnelId: values?.assigner }),
      };

      const response = await CRMService.postAssigned(payload);

      if (response?.isError) {
        message.error("Assigned thất bại!")
      } else {
        onCancel()
        setSelectedRowKeys([])
        getData(1, 50, status)
        message.success("Assigned thành công!")
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Có lỗi xảy ra!")
      console.log("handleSave error", error)
    } finally {
      setLoading(false)
    }
  }

  const removeVietnameseTones = str =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D")

  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" initialValues={{}}>
        <Row>
          <Col span={24}>
            <Form.Item label="Assign theo">
              <Radio.Group
                value={assignType}
                onChange={(e) => setAssignType(e.target.value)}
                options={[
                  { value: "department", label: 'Phòng ban' },
                  { value: "person", label: 'Nhân viên sale' },]}
              />
            </Form.Item>
          </Col>
          <Col span={24} className="pr-16">
            <Form.Item label="Chọn phòng ban:">
              <SelectStyle
                mode="multiple"
                placeholder="Phòng ban"
                allowClear
                showSearch
                optionFilterProp="label"
                value={departmentId}
                onChange={value => {
                  setDepartmentId(value || [])
                  form.setFieldsValue({ assigner: [] })
                }}
                options={listDepartment.map(item => ({
                  value: item.ID,
                  label: item.title,
                }))}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
          {assignType === "person" ?
            <Col span={24} className="pr-16">
              <Form.Item
                label="Chọn người phụ trách:"
                name="assigner"
              >
                <Select
                  mode="multiple"
                  placeholder="Chọn người phụ trách"
                  allowClear
                  optionLabelProp="label"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const inputText = removeVietnameseTones(input.toLowerCase())
                    const optionText = removeVietnameseTones(
                      (option?.label ?? "").toLowerCase(),
                    )
                    return optionText.includes(inputText)
                  }}
                >
                  {assignerList.map(assigner => (
                    <Select.Option
                      key={assigner.ID}
                      value={assigner.ID}
                      label={assigner.name}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>{assigner.name}</span>
                        <Tag bordered={false} color="blue">
                          {assigner?.positions?.title}
                        </Tag>
                      </div>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            :
            <></>
          }


          <Col span={24}>
            <div className="d-flex justify-content-flex-end pt-40">
              <Button
                btnType="back"
                className="btn-hover-shadow mr-15"
                onClick={onCancel}
              >
                Hủy bỏ
              </Button>
              <Button
                btnType="primary"
                className="btn-hover-shadow"
                onClick={handleSave}
              >
                {loading ? <LoadingOutlined /> : "Lưu lại"}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Spin>
  )
}

ModalAssigner.propTypes = {
  open: PropTypes.array,
  getData: PropTypes.func,
  onCancel: PropTypes.func,
  dataSelected: PropTypes.array,
  status: PropTypes.any,
  setSelectedRowKeys: PropTypes.func,
}

ModalAssigner.defaultProps = {
  open: [],
  getData: () => { },
  onCancel: () => { },
  dataSelected: [],
  status: null,
  setSelectedRowKeys: () => { },
}

export default ModalAssigner
